import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

interface CTACardProps {
  variant?: "primary" | "secondary";
}

const CTACard = ({ variant = "primary" }: CTACardProps) => (
  <div className={`rounded-2xl p-8 md:p-12 text-center ${variant === "primary" ? "bg-gradient-to-br from-primary/20 via-primary/10 to-accent/20 border border-primary/30" : "bg-gradient-to-br from-accent/20 via-secondary/30 to-primary/10 border border-accent/30"}`}>
    <h3 className="text-2xl md:text-3xl font-bold text-foreground mb-4">
      {variant === "primary" ? "Pronto para transformar seus hábitos?" : "Comece sua jornada agora!"}
    </h3>
    <p className="text-muted-foreground mb-6 max-w-lg mx-auto">
      {variant === "primary" 
        ? "O HabitFrog vai te ajudar a criar e manter hábitos produtivos com gamificação divertida e acompanhamento visual."
        : "Junte-se a milhares de pessoas que já transformaram suas rotinas. É grátis para começar!"
      }
    </p>
    <Link to="/auth">
      <Button size="lg" className="text-lg px-8 py-6 rounded-full">
        Começar Grátis <ArrowRight className="ml-2 h-5 w-5" />
      </Button>
    </Link>
  </div>
);

export default CTACard;
